export default "/images/calendar.svg?481f788e46430e2681ebb2879408408b";